<template>
  <v-expansion-panels
    v-model="panel"
    multiple
  >
    <v-expansion-panel>
      <v-expansion-panel-header class="text-h6">
        Clicked Links
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <template v-if="panel.includes(0)">
          <v-lazy
            :options="{
              threshold: .5
            }"
            min-height="145"
            transition="fade-transition"
          >
            <component-body />
          </v-lazy>
        </template>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
export default {
  components: {
    componentBody: () => import('./component-body.vue')
  },
  data () {
    return {
      panel: []
    }
  }
}
</script>